export const list = (dispatch, apiClient) => apiClient
  .call({
    endpoint: 'action/list',
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ACTION_SET', payload: res.data });
    return res;
  });

export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'action/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ACTION_SET', payload: res.data });
    return res;
  });

export const remove = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'action/remove', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ACTION_SET', payload: res.data });
    return res;
  });

export const create = (dispatch, apiClient, name, type, data = {}) => apiClient
  .call({ endpoint: 'action/new', data: { name, type, data } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ACTION_SET', payload: res.data.action });
    return res;
  });

export const update = (dispatch, apiClient, id, changes = {}) => apiClient
  .call({ endpoint: 'action/update', data: { id, changes } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'ACTION_SET', payload: res.data });
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/actions.js